import { CoralogixRum } from '@coralogix/browser';

export function reportTelemetryError(
  error: unknown,
  props?: Record<string, unknown>,
  labels?: Record<string, string>,
): void {
  if (!CoralogixRum.isInited) {
    return;
  }

  const normalizedError =
    error instanceof Error ? error : new Error(String(error));

  CoralogixRum.captureError(normalizedError, props, labels);
}
